import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/orrbiitheader";
import Footer from "../../components/footerorrbiit";

import beautyImg from "./dummy.jpg";
import cabImg from "./dummy.jpg";
import ngoImg from "./dummy.jpg";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import "./orrbiithome.css";

const OrrbiitHome = () => {
  const navigate = useNavigate();

  const companies = [
    {
      title: "ORRBIIT Elegance",
      subtitle: "Beauty at Home",
      description: "Salon & beauty services at your doorstep",
      image: beautyImg,
      link: "/orrbiitelegance",
      priceText: "Starts @399",
    },
    {
      title: "ORRBIIT Go",
      subtitle: "Smart Travel",
      description: "Reliable cab & travel services",
      image: cabImg,
      link: "/orrbiitgo",
      priceText: "Starts @20/km",
    },
    {
      title: "ORRBIIT Relief",
      subtitle: "For Humanity",
      description: "NGO services & social impact initiatives",
      image: ngoImg,
      link: "/orrbiitrelief/home",
      priceText: "Donate @99",
    },
  ];

  return (
    <>
      <Header />

      {/* ================= HERO CAROUSEL ================= */}
      <div
        id="heroCarousel"
        className="carousel slide carousel-fade"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          {[
            {
              title: "ORRBIIT Group",
              text: "One Vision. Multiple Ventures.",
              img: beautyImg,
            },
            {
              title: "Premium Services",
              text: "Beauty, Travel & Social Impact",
              img: cabImg,
            },
            {
              title: "Customer First",
              text: "Quality. Trust. Innovation.",
              img: ngoImg,
            },
          ].map((item, index) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <div
                className="hero-slide"
                style={{ backgroundImage: `url(${item.img})` }}
              >
                <div className="hero-overlay">
                  <h1>{item.title}</h1>
                  <p>{item.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ================= COMPANY CARDS ================= */}
     <section className="container mt-2 mb-3">
        <div className="text-center mb-3">
          <h2 className="fw-bold">Our Ventures</h2>
          <p className="text-muted">Explore our group services</p>
        </div>

        {/* 🔥 UPDATED GRID */}
        <div className="row g-3 justify-content-center">
          {companies.map((company, idx) => (
            <div key={idx} className="col-6 col-md-4 col-lg-3">
              <div
                className="company-card"
                onClick={() => navigate(company.link)}
              >
                <div className="company-img-wrapper">
                  <img
                    src={company.image}
                    alt={company.title}
                    className="company-img"
                  />

                  <div className="company-price-strip">
                    {company.priceText}
                  </div>
                </div>

                <div className="company-content">
                  <h4>{company.title}</h4>

                  <span className="company-subtitle">
                    {company.subtitle}
                  </span>

                  <p>{company.description}</p>

                  <button className="btn btn-dark">
                    Explore
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ================= WHY CHOOSE US ================= */}
      <section className="why-section text-center">
        <div className="container">
          <h2 className="fw-bold mb-3">Why Choose ORRBIIT</h2>

          <div className="row g-4">
            {[
              { icon: "bi-shield-check", title: "Trust & Reliability" },
              { icon: "bi-lightning-charge", title: "Fast & Efficient" },
              { icon: "bi-star-fill", title: "Premium Quality" },
            ].map((item, i) => (
              <div key={i} className="col-md-4">
                <div className="why-card">
                  <i className={`bi ${item.icon}`}></i>
                  <h5>{item.title}</h5>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= WHAT WE PROVIDE ================= */}
      <section className="provide-section text-center">
        <div className="container">
          <h2 className="fw-bold mb-3">What We Provide</h2>

          <div className="row g-4">
            {[
              "Home Beauty Services",
              "Cab & Travel Solutions",
              "NGO & Social Services",
            ].map((text, i) => (
              <div key={i} className="col-md-4">
                <div className="provide-card">
                  <h5>{text}</h5>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default OrrbiitHome;